//formatters

const permissionsProvider = {
    canCreate: (acl) => acl === undefined ||
        acl === null || !Array.isArray(acl.deny) || !acl.deny.includes('create'),
    canDelete: (acl) => acl === undefined ||
        acl === null || !Array.isArray(acl.deny) || !acl.deny.includes('delete'),
    canEdit: (acl) => acl === undefined ||
        acl === null || !Array.isArray(acl.deny) || !acl.deny.includes('edit'),
    isMinUser: (userType) => {
        const userTypes = [
            { name: 'User', value: 1 },
            { name: 'Manager', value: 2 },
            { name: 'Administrator', value: 3 },
            { name: 'GlobalAdministrator', value: 4 }
        ];

        const userTypeToCheck = userTypes.find(u => u.name === userType);
        if (!userTypeToCheck) return false;

        const currentUserType = userTypes.find(u => u.name === window.biztrax.userType);
        if (!currentUserType) return false;

        return currentUserType.value >= userTypeToCheck.value;
    }
}

export default permissionsProvider;